import axios from "../interceptors";

const ShopifyOrderService = {};

ShopifyOrderService.getChannels = async ({ token, merchantId }) => {
  const url = `shopify/salesChannels?merchantId=${merchantId}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export default ShopifyOrderService;
